import { Users, Home, Timer, Award } from 'lucide-react';
import { useEffect, useState } from 'react';

interface StatItemProps {
  icon: React.ReactNode;
  value: number;
  label: string;
  suffix?: string;
  delay: number;
}

const StatItem = ({ icon, value, label, suffix = '', delay }: StatItemProps) => {
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      let start = 0;
      const end = value;
      const duration = 2000;
      const increment = end / (duration / 16);
      
      const timer = setInterval(() => {
        start += increment;
        if (start > end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      
      return () => clearInterval(timer);
    }, delay);
    
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return (
    <div className="seafarer-card py-8 px-4 text-center animate-fade-in" style={{ animationDelay: `${delay}ms` }}>
      <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-seafarer-orange/20 to-seafarer-purple/20 mb-4">
        {icon}
      </div>
      <h3 className="text-3xl md:text-4xl font-bold mb-2 gradient-text">{count}{suffix}</h3>
      <p className="text-gray-600 dark:text-gray-300">{label}</p>
    </div>
  );
};

const StatsSection = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="page-container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Impact</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Since our establishment in 2021, we have made significant progress towards our goals.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <StatItem 
            icon={<Users className="h-8 w-8 text-seafarer-orange" />}
            value={588}
            label="Active Members"
            delay={100}
          />
          <StatItem 
            icon={<Home className="h-8 w-8 text-seafarer-purple" />}
            value={200}
            label="Houses Planned (Phase 1, 2025-2026)"
            delay={300}
          />
          <StatItem 
            icon={<Timer className="h-8 w-8 text-seafarer-blue" />}
            value={2}
            label="Years Since Establishment"
            delay={500}
          />
          <StatItem 
            icon={<Award className="h-8 w-8 text-seafarer-red" />}
            value={880}
            label="Funds Raised (in thousands N$)"
            suffix="k"
            delay={700}
          />
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
